<template>
  <el-dialog
    top="10vh"
    :title="title"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="showModel"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="auto"
      size="small"
      label-suffix=": "
    >
      <el-form-item :label="$t('Fota.taskName')" prop="name">
        <el-input
          v-model.trim="form.name"
          :placeholder="$t('Common.maxLengthTips16')"
          :maxlength="16"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('Fota.firmwareModel')" prop="firmwareModelId">
        <Select
          :query="$api.fota.firmware_page"
          v-model="form.firmwareModelId"
          :placeholder="$t('Common.tipsSelect1')"
          :labelOptions="{
            key: 'id',
            value: 'name'
          }"
          @getRaw="handleFirmwareModelId"
        />
      </el-form-item>
      <el-form-item
        :label="$t('Fota.VersionToUpgrade')"
        prop="srcVersion"
        v-if="this.targetType === 'VERSION'"
      >
        <!--        :query="$api.fota.firmware_list + '?firmwareType=' + type"-->
        <Select
          multiple
          :options="srcVersionList"
          v-model="form.srcVersion"
          :placeholder="$t('Fota.tips18')"
          :labelOptions="{
            key: 'version',
            value: 'version'
          }"
        />
      </el-form-item>
      <el-form-item :label="$t('Fota.destVersionUpgrade')" prop="destVersionId">
        <!--          :options="destNewList"-->
        <Select
          :options="destNewList"
          v-model="form.destVersionId"
          :placeholder="$t('Common.tipsSelect1')"
          :labelOptions="{
            key: 'id',
            value: 'version'
          }"
        />
      </el-form-item>
      <el-form-item :label="$t('Fota.approver')" prop="examineAdminId">
        <Select
          :query="$api.fota.task_auditor_list"
          v-model="form.examineAdminId"
          :placeholder="$t('Common.tipsSelect1')"
          :labelOptions="{
            key: 'id',
            value: 'name'
          }"
        />
      </el-form-item>
      <!--      <el-form-item label="升级方式" prop="upgradeType">-->
      <!--        <el-radio-group v-model="form.upgradeType">-->
      <!--          <el-radio label="NOT_FORCE">自主升级</el-radio>-->
      <!--          <el-radio label="FORCE">强制升级</el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->
      <el-form-item :label="$t('Fota.updateStartTime')" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          :editable="false"
          type="datetime"
          :placeholder="$t('Fota.updateStartTime')"
          format="yyyy-MM-dd HH:mm"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('Fota.upgradeCondition')" prop="" v-if="form.firmwareModelId">
        <div style="">
          <div style="margin-right: 16px">
            <div
              v-for="(item, index) in upgradeConditionList"
              :key="index"
              style="display: flex;margin-bottom: 8px"
            >
              <Select
                class="selInput"
                :options="propertyList"
                v-model="item.fieldName"
                :placeholder="$t('Product.property')"
                :disabledCode="upgradeConditionList.map((Con) => Con.fieldName)"
                :labelOptions="{
                  key: 'identifier',
                  value: 'name'
                }"
              />
              <Select
                class="selInput"
                :options="connList"
                v-model="item.queryType"
                :placeholder="$t('Common.tipsSelect1')"
              />
              <el-input
                class="selInput"
                v-model="item.fieldValue"
                :placeholder="$t('Fota.propertyValue')"
              ></el-input>
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('Common.delete')"
                placement="top-start"
              >
                <div class="iconDiv" @click="deleteProperty(index)">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-del_16"></use>
                  </svg>
                </div>
              </el-tooltip>
            </div>
          </div>
          <div>
            <hl-button @click="addProperty" type="secondary">
              {{ $t('Common.create') }}
            </hl-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('Fota.DeviceToUpgrade')"
        prop="targetDevice"
        v-if="this.targetType === 'DEVICE'"
      >
        <div class="textarea-div">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model.trim="form.targetDevice"
            resize="none"
            :placeholder="$t('Fota.DeviceToUpgradeTips')"
            @input="targetDeviceChange"
          ></el-input>
          <div class="textarea-more">
            <el-upload
              style="display: inline-block;"
              :action="$api.fota.task_extract_device"
              :headers="{
                Authorization: token
              }"
              name="deviceFile"
              accept=".txt,.xls,.xlsx"
              :on-success="fileUpload"
              :show-file-list="false"
            >
              <el-button size="mini">{{ $t('Common.importData') }}</el-button>
            </el-upload>
            <span class="file-type"> {{ $t('Fota.fileFormat') }} </span>
            <el-button size="text" style="font-size: 12px;" @click="handleImportModel">{{
              $t('Common.downloadTemplate')
            }}</el-button>
            <div class="total">{{ $t('Fota.total') }} {{ deviceTotal }}</div>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('Common.remark')" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          maxlength="100"
          show-word-limit
          v-model.trim="form.remark"
          resize="none"
          :placeholder="$t('Common.remark')"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">{{ $t('Common.cancel') }}</el-button>
      <el-button type="primary" size="small" @click="save" :loading="loading">{{
        $t('Common.save')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { downloadFile } from '@/utils/download'
import { formatTime } from '@/utils/utils'
import Select from '@/components/CommonForm/Select'
export default {
  props: {
    showModel: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    targetType: {
      type: String
    },
    destVersionList: {
      type: Array
    }
  },
  components: {
    Select
  },
  data() {
    return {
      pickerOptions: {
        // 限制升级开始时间不让选择今天以前的
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      title: '',
      form: {
        name: '',
        firmwareModelId: '',
        srcVersion: [],
        destVersionId: '',
        examineAdminId: '',
        upgradeType: 'NOT_FORCE',
        startTime: '',
        targetDevice: '',
        remark: ''
      },
      destNewList: [],
      srcVersionList: [],
      rules: {
        name: [
          {
            required: true,
            message: this.$t('Fota.taskName'),
            trigger: 'blur'
          }
        ],
        firmwareModelId: [
          {
            required: true,
            message: this.$t('Fota.upgradeCondition'),
            trigger: ['blur', 'change']
          }
        ],
        srcVersion: [
          {
            required: true,
            message: this.$t('Fota.VersionToUpgrade'),
            trigger: ['blur', 'change']
          }
        ],
        destVersionId: [
          {
            required: true,
            message: this.$t('Fota.destVersionUpgrade'),
            trigger: ['blur', 'change']
          }
        ],
        examineAdminId: [
          {
            required: true,
            message: this.$t('Fota.approver'),
            trigger: ['blur', 'change']
          }
        ],
        // upgradeType: [
        //   {
        //     required: true,
        //     message: '请选择升级方式',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        startTime: [
          {
            required: true,
            message: this.$t('Fota.updateStartTime'),
            trigger: ['blur', 'change']
          }
        ],
        targetDevice: [
          {
            required: true,
            message: this.$t('Fota.DeviceToUpgrade'),
            trigger: ['blur', 'change']
          }
        ]
      },
      deviceTotal: 0,
      token: localStorage.getItem('login_token'),
      loading: false,
      propertyList: [],
      connList: [
        {
          code: 'gte',
          name: '>='
        },
        {
          code: 'lte',
          name: '<='
        },
        {
          code: 'gt',
          name: '>'
        },
        {
          code: 'lt',
          name: '<'
        },
        {
          code: 'eq',
          name: '='
        }
      ],
      upgradeConditionList: []
    }
  },
  mounted() {
    if (this.targetType === 'DEVICE') {
      this.title = this.$t('Fota.titleDevice')
    }
    if (this.targetType === 'VERSION') {
      this.title = this.$t('Fota.titleVersion')
    }
    this.destNewList = this.destVersionList
  },
  watch: {
    'form.firmwareModelId': {
      handler(newVal, oldval) {
        this.$set(this.form, 'destVersionId', '')
        this.getDestNewList(newVal)
        this.getSrcVersionList(newVal)
      }
    }
  },
  methods: {
    deleteProperty(index) {
      this.upgradeConditionList.splice(index, 1)
    },
    // 添加升级条件
    addProperty() {
      this.upgradeConditionList.push({
        fieldName: '',
        fieldValue: '',
        queryType: ''
      })
    },
    handleFirmwareModelId(row) {
      this.propertyList = []
      this.upgradeConditionList = []
      console.log('handleFirmwareModelId', row)
      if (row.productKey) {
        console.log()
        const params = {
          productKey: row.productKey
        }
        this.$ajax
          .get(this.$api.product.product_tsl_property_list, params)
          .then((res) => {
            if (res.data) {
              this.$nextTick(() => {
                this.propertyList = res.data
              })
            }
          })
          .catch(() => {})
      }
    },
    getDestNewList(firmwareModelId) {
      let params = {
        firmwareType: 'DTU',
        enable: true,
        firmwareModelId: firmwareModelId
      }
      this.$ajax.get(this.$api.fota.firmware_list, params).then((res) => {
        this.destNewList = res.data
      })
    },
    getSrcVersionList(firmwareModelId) {
      let params = {
        firmwareType: 'DTU',
        firmwareModelId: firmwareModelId
      }
      this.$ajax.get(this.$api.fota.firmware_list, params).then((res) => {
        this.srcVersionList = res.data
      })
    },
    handleImportModel() {
      this.$ajax.download(this.$api.fota.task_device_template).then((res) => {
        downloadFile(res)
      })
    },
    fileUpload(res) {
      if (res.success) {
        this.form.targetDevice = res.data
        this.getDeviceTotal()
      } else {
        this.$message.error(res.msg)
      }
    },
    targetDeviceChange() {
      this.getDeviceTotal()
    },
    getDeviceTotal() {
      let deviceList = this.form.targetDevice ? this.form.targetDevice.split(',') : []
      this.deviceTotal = deviceList.length
    },
    close() {
      this.$emit('update:showModel', false)
    },
    //判断一个数组对象是否填写完整
    isObject(list) {
      let flag = true
      for (let i = 0; i < list.length; i++) {
        let form = list[i]
        if (form) {
          let add = 0
          let del = 0
          let keys = Object.keys(form)
          keys.forEach((key) => {
            // isLocalhost && console.log("key", key, form[key]);
            if (form[key] === null || form[key] === '' || form[key] === undefined) {
              add++
            } else {
              del++
            }
          })
          if (del === keys.length) {
            // this.$message.warning("此项没有属性为空")
          }
          // else if(add === keys.length)
          //   {
          //     this.$message.warning("或者此项全空")
          //   }
          else {
            // isLocalhost && console.log("此项存在空属性", keys.length, add, del);
            this.$message.warning(`${this.$t('Fota.tips21')}`)
            return (flag = false)
          }
        }
      }
      return flag
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      let isListValidate = this.isObject(this.upgradeConditionList)
      return pass && isListValidate
    },
    checkVersion() {
      if (!this.checkForm()) return
      this.loading = true
      let destVersion = ''
      this.destVersionList.map((item) => {
        if (item.id === this.form.destVersionId) {
          destVersion = item.version
        }
      })
      let params = {
        srcVersion: this.form.srcVersion.join(),
        destVersion: destVersion
      }
      this.$ajax
        .get(this.$api.fota.task_check_version, params)
        .then((res) => {
          if (res.data.trouble) {
            this.$confirm(`${this.$t('Fota.tips19')}`, `${this.$t('Fota.tips20')}`, {
              confirmButtonText: `${this.$t('Common.confirm')}`,
              cancelButtonText: `${this.$t('Common.cancel')}`,
              type: 'warning',
              center: true
            })
              .then(() => {
                this.submit()
              })
              .catch(() => {})
          } else {
            this.submit()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    submit() {
      let upgradeConditionList = this.upgradeConditionList || []
      let params = {
        firmwareType: this.type,
        name: this.form.name,
        firmwareModelId: this.form.firmwareModelId,
        destVersionId: this.form.destVersionId,
        examineAdminId: this.form.examineAdminId,
        upgradeType: this.form.upgradeType,
        startTime: formatTime(this.form.startTime, 'YYYY-MM-DD HH:mm'),
        remark: this.form.remark,
        upgradeCondition: JSON.stringify(upgradeConditionList)
      }
      if (this.targetType === 'DEVICE') {
        params.targetDevice = this.form.targetDevice
      }
      if (this.targetType === 'VERSION') {
        params.srcVersion = this.form.srcVersion.join()
      }
      let api = this.$api.fota.task_insert
      this.$ajax
        .post(api, params)
        .then(() => {
          this.$message.success(`${this.$t('Common.createSuccess')}`)
          this.close()
          this.$emit('refresh')
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.checkVersion()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .selInput {
  margin-right: 8px;
  width: 140px !important;
  .el-input.el-input--small.el-input--suffix {
    width: 140px !important;
  }
}
.textarea-div {
  width: 342px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  /deep/ .el-textarea {
    textarea {
      border: none;
    }
  }
  .textarea-more {
    margin: 0 15px;
    padding: 8px 0;
    border-top: 1px solid #dcdcdc;
    .file-type {
      font-size: 12px;
      color: #999999;
    }
    .total {
      float: right;
      line-height: 38px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
